
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import UpdateFontFace from "@/components/Settings/Preferences/CustomFonts/components/UpdateFontFace.vue";
import { FontFace, FontFile } from "@/types/custom-fonts";
import FontFileUpload from "@/components/Settings/Preferences/CustomFonts/components/FontFileUpload.vue";
import { v4 as uuidv4 } from "uuid";

@Component({
  components: {
    FontFileUpload,
    UpdateFontFace
  }
})
export default class FontFaces extends Vue {
  @Prop()
  value!: FontFace[];

  newFontFileSuccessfullyUploaded(fontFile: FontFile) {
    const newFontFace = fontFileToBlankFontFace(fontFile);
    const newFontFaces = [...this.value, newFontFace];
    this.$emit("input", newFontFaces);
  }

  updateFontFace(newFontFace: FontFace, fontFaceIndex: number) {
    const newFontFaces = [...this.value];
    const newFontFaceFormats = newFontFace.files.map(file => file.format);

    // If the weight and style are the same but the format is different
    // Merge the newFontFace's files into an existing font face
    const indexOfMatchingFontFace = newFontFaces.findIndex(
      fontFace =>
        fontFace.weight === newFontFace.weight &&
        fontFace.style === newFontFace.style &&
        // Doesn't match the file formats
        !fontFace.files.find(file => newFontFaceFormats.includes(file.format))
    );

    if (indexOfMatchingFontFace === -1) {
      newFontFaces[fontFaceIndex] = newFontFace;
    } else {
      // Merge the files
      newFontFaces[indexOfMatchingFontFace].files = [
        ...newFontFaces[indexOfMatchingFontFace].files,
        ...newFontFace.files
      ];

      // And remove the merged font face from the list
      newFontFaces.splice(fontFaceIndex, 1);
    }

    this.$emit("input", newFontFaces);
  }

  deleteFontFace(fontFaceIndex: number) {
    const newFontFaces = [...this.value];
    newFontFaces.splice(fontFaceIndex, 1);
    this.$emit("input", newFontFaces);
  }

  existingFontFaces(fontFaceIndex: number) {
    return this.value.filter((_, i) => i !== fontFaceIndex);
  }
}

function fontFileToBlankFontFace(fontFile: FontFile): FontFace {
  return {
    id: uuidv4(),
    files: [fontFile],
    style: "normal",
    weight: 0
  };
}
